import React from "react";
import { Link } from "react-router-dom";
import "./LoanProduct.css";
import "./PersonalLoan.css";

const PersonalLoan = () => {
  return (
    <main className="loan-page">
      <section className="loan-hero personal-loan-hero">
        <div className="loan-hero-inner cb-rise">
          <h1>Personal loan assistance from trusted lenders</h1>
          <p>
            Core Bankers matches your profile with banks and NBFCs — no customer fees, no hidden charges.
            As an RBI-compliant DSA, we connect you directly with approved lenders.
          </p>
          <Link to="/eligibility" className="cb-btn">
            Check Eligibility
          </Link>
        </div>
      </section>

      <div className="loan-content">
        <section className="loan-section">
          <h2>Why choose Core Bankers</h2>
          <ul>
            <li>We work only with RBI-registered banks and NBFCs</li>
            <li>Free assistance with no middlemen fees from our side</li>
            <li>Clear guidance on documentation and eligibility</li>
            <li>Recommendations tailored to your income and credit profile</li>
            <li>Support through every step until the lender decides</li>
          </ul>
        </section>

        <section className="loan-section">
          <h2>Eligibility criteria</h2>
          <ul>
            <li>Age typically between 21 and 60 years</li>
            <li>Minimum monthly income as per lender policy (often around ₹25,000+)</li>
            <li>Valid PAN, Aadhaar, and address proof</li>
            <li>Stable income (salaried or self-employed)</li>
            <li>Healthy credit history (650+ preferred)</li>
          </ul>
        </section>

        <section className="loan-section">
          <h2>Documents required</h2>
          <ul>
            <li>PAN Card and Aadhaar Card</li>
            <li>Bank statement (last 6 months)</li>
            <li>Recent salary slips or ITR documents</li>
            <li>Address proof (utility bill or rental agreement)</li>
            <li>Passport-size photograph</li>
          </ul>
        </section>

        <section className="loan-section">
          <h2>How it works</h2>
          <ol>
            <li>Share your basic details through eligibility check or enquiry</li>
            <li>We assess your profile and match suitable lenders</li>
            <li>The lender verifies documents and eligibility</li>
            <li>Approval and disbursal happen directly with the lender</li>
          </ol>
        </section>

        <section className="loan-cta">
          <h2>Start with a clear estimate</h2>
          <p>Compare personal loan estimates from partner lenders before you apply.</p>
          <Link to="/eligibility" className="cb-btn">
            Check Eligibility
          </Link>
        </section>
      </div>
    </main>
  );
};

export default PersonalLoan;
